<div class="container">
    <div class="settings-block">
        <button ion-button icon-only clear (click)="onCloseClick()">
            <ion-icon color="secondary" name="close-circle" class="settings-btn"></ion-icon>
        </button>
    </div>
    <div class="buttons-block">
        <button ion-button small class="share-btn" (click)="onAddPlayerClick()">{{ 'ADD_PLAYER' | translate }}</button>
    </div>
</div>